import React from "react";
import Table from "../../../../Table";
import config from "../../../../../axios";
import i18next from "i18next";

const Outside = () => {
  const { language } = i18next;

  const [schedule, setSchedule] = React.useState();

  React.useEffect(() => {
    config.get(`/${language}/api/schedule-international/`).then((res) => {
      setSchedule(res.data || []);
    });
  }, []);

  return (
    <div className="w-full px-3">
      <div className="container mx-auto">
        <Table props={schedule} />
      </div>
    </div>
  );
};

export default Outside;
